import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { ProcCodeSelect } from "../ui/ProcCodeSelect";
import { MachCodeSelect } from "../ui/MachCodeSelect";
import Modal from "../ui/Modal";
import BadqueryScanner from "../scanner/BadqueryScanner";
import {
  setMachSeq,
  fetchDefects,
  setProcCode,
  setMachCode,
  feachWorkStatus,
} from "../../redux/defectsSlice";
import "./DefectsInfo.css";
import { toNumber } from "lodash";

const DefectsInfo: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  // スキャナ用モーダル制御
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeQrModal = () => {
    setIsModalOpen(false);
  };

  // 不良情報
  const defects = useSelector((state: RootState) => state.defects);
  // 発見加工選択処理
  const handleProcCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setProcCode(e.target.value));
  };
  // 機械選択処理
  const handleMachCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setMachCode(e.target.value));
  };
  // 工順変更
  const handleMachSeqChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setMachSeq(toNumber(e.target.value)));
  };
  // 受注Noがセットされていない場合はスキャナを起動
  useEffect(() => {
    if (defects.procParams.poDescNum === "") {
      openModal();
    }
  }, [defects.procParams.poDescNum]);

  useEffect(() => {
    console.log("作業者リスト取得");
    dispatch(
      feachWorkStatus(
        defects.defectsInfo.plantCode,
        defects.defectsInfo.procCode
      )
    );
  }, [defects.defectsInfo.plantCode, defects.defectsInfo.procCode]);

  useEffect(() => {
    console.log("⭐️不良情報取得");
    console.log(defects.defectsInfo);
    if (defects.defectsInfo.mach_seq > 0) {
      dispatch(fetchDefects(defects.defectsInfo));
    }
  }, [defects.defectsInfo.mach_seq]);

  const errorMessage = defects.defectsInfo.inputErrors.map((d) => {
    return <p className="defects-info-errors">{d}</p>;
  });

  return (
    <div className="defects-info-container">
      <div className="defects-info-title-item defects-heading-container">
        <img src="images/defects.svg" alt="" />
        <h1>不良情報</h1>
      </div>
      <div className="defects-info-errors-item">{errorMessage}</div>
      <div className="defects-info-scanner-item">
        <div className="defects-scanner-container" onClick={openModal}>
          <img
            src="images/camera.svg"
            alt="Start Scanner"
            className="icon myShadow"
          />
          <p>スキャナ起動</p>
        </div>
        <Modal
          isOpen={isModalOpen}
          onClose={closeQrModal}
          width="800px"
          height="560px"
          contentClassName={""}
        >
          <BadqueryScanner isOpen={isModalOpen} onClose={closeQrModal} />
        </Modal>
      </div>
      {defects.defectsInfo.po_desc_num !== "" && (
        <>
          <div className="defects-proc-item">
            <ProcCodeSelect
              label="発見加工"
              plantCode={defects.defectsInfo.plantCode}
              selectProcCode={defects.defectsInfo.procCode}
              handleProcCodeChange={handleProcCodeChange}
              filter={defects.procCodeMaster}
            ></ProcCodeSelect>
          </div>
          <div className="defects-mach-item">
            <MachCodeSelect
              label="発見機械"
              plantCode={defects.defectsInfo.plantCode}
              procCode={defects.defectsInfo.procCode}
              selectMachCode={defects.defectsInfo.machCode}
              handleMachCodeChange={handleMachCodeChange}
              filter={defects.machCodeMaster}
            ></MachCodeSelect>
          </div>
          <div className="defects-po_desc_num-item">
            <div className="defects-textbox-container-140 defects-textbox-container-bold">
              <label htmlFor="orderno">受注NO</label>
              <input
                id="orderno"
                name="orderno"
                type="text"
                readOnly
                value={defects.defectsInfo.po_desc_num}
              />
            </div>
          </div>
          <div className="defects-machseq-item">
            <div className="defects-textbox-container-130 defects-textbox-container-bold">
              <label htmlFor="machseq">工順</label>
              <select
                id="machseq"
                onChange={handleMachSeqChange}
                value={defects.defectsInfo.mach_seq}
              >
                {defects.machSeqOptions
                  .filter(
                    (d) =>
                      d.proc_code === defects.defectsInfo.procCode &&
                      d.mach_code === defects.defectsInfo.machCode
                  )
                  .map((d, index) => (
                    <option key={index} value={d.mach_seq}>
                      {d.mach_seq} : {d.mach_name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="defects-product_name-item">
            <div className="defects-textbox-container-212">
              <label htmlFor="variety">商品名</label>
              <input
                id="variety"
                name="variety"
                type="text"
                readOnly
                value={defects.defectsInfo.product_name}
              />
            </div>
          </div>
          <div className="defects-order_dim-item">
            <div className="defects-textbox-container-140">
              <label htmlFor="size">寸法</label>
              <input
                id="size"
                name="size"
                type="text"
                readOnly
                value={`${defects.defectsInfo.order_dim_w} x ${defects.defectsInfo.order_dim_h}`}
              />
            </div>
          </div>
          <div className="defects-currentQty-item">
            <div className="defects-textbox-container-140">
              <label htmlFor="quantity">計画数</label>
              <input
                id="quantity"
                name="quantity"
                type="text"
                readOnly
                value={defects.defectsInfo.currentQty}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DefectsInfo;
